import React from 'react';

const Linkedin = () => (
  <svg
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
  >
    <g>
      <path
        className="semiCircle"
        fill="#0173B2"
        d="M12,1c6.075,0,11,4.925,11,11s-4.925,11-11,11S1,18.075,1,12S5.925,1,12,1"
      />
      <path
        fill="#F4F4F4"
        d="M12.824,8.942c-0.09-0.27-0.279-0.405-0.567-0.405h-1.359v9.234h2.223v-6.678
            c0.301-0.3,0.618-0.537,0.954-0.711s0.696-0.262,1.08-0.262c0.527,0,0.921,0.155,1.179,0.464c0.258,0.31,0.388,0.746,0.388,1.31
            v5.877h2.223v-5.877c0-0.516-0.067-0.988-0.202-1.418c-0.136-0.429-0.334-0.798-0.594-1.106c-0.262-0.31-0.588-0.549-0.977-0.72
            c-0.391-0.172-0.838-0.257-1.342-0.257c-0.313,0-0.6,0.031-0.864,0.095c-0.264,0.063-0.512,0.149-0.742,0.261
            c-0.231,0.111-0.45,0.246-0.657,0.405s-0.403,0.331-0.59,0.518L12.824,8.942 M8.819,5.288C8.742,5.114,8.638,4.965,8.509,4.839
            C8.38,4.713,8.229,4.612,8.055,4.537C7.88,4.462,7.694,4.425,7.497,4.425c-0.192,0-0.374,0.037-0.544,0.112
            s-0.32,0.176-0.446,0.302S6.28,5.114,6.205,5.288C6.13,5.463,6.092,5.648,6.092,5.847c0,0.192,0.038,0.372,0.113,0.54
            C6.28,6.555,6.38,6.701,6.506,6.827s0.275,0.227,0.446,0.302s0.352,0.112,0.544,0.112c0.198,0,0.384-0.037,0.558-0.112
            C8.229,7.054,8.38,6.953,8.509,6.827c0.129-0.126,0.233-0.272,0.311-0.44c0.078-0.168,0.117-0.348,0.117-0.54
            C8.937,5.648,8.897,5.463,8.819,5.288 M6.398,8.537v9.234H8.63V8.537H6.398"
      />
      <path
        fill="#E9E8E8"
        d="M4.144,19.699L4.144,19.699c0.016,0.018,0.033,0.034,0.05,0.051C4.177,19.733,4.161,19.717,4.144,19.699
            M19.7,4.144L19.7,4.144c0.017,0.017,0.034,0.034,0.051,0.051C19.734,4.177,19.717,4.161,19.7,4.144"
      />
      <path
        className="semiCircle"
        fill="#046AA3"
        d="M19.699,4.144l-4.268,4.268c0.128-0.012,0.261-0.018,0.398-0.018c0.504,0,0.951,0.085,1.342,0.257
            c0.389,0.171,0.715,0.41,0.977,0.72c0.26,0.309,0.458,0.678,0.594,1.106c0.135,0.43,0.202,0.902,0.202,1.418v5.877h-2.223v-5.877
            c0-0.563-0.13-1-0.388-1.31c-0.258-0.309-0.651-0.464-1.179-0.464c-0.384,0-0.744,0.088-1.08,0.262s-0.653,0.411-0.954,0.711v6.678
            h-2.223v-4.826L8.63,15.214v2.558H6.398v-0.326l-2.254,2.254c0.017,0.018,0.033,0.034,0.05,0.051
            c1.987,1.961,4.716,3.172,7.728,3.172c6.075,0,11-4.925,11-11c0-3.012-1.211-5.741-3.171-7.728
            C19.734,4.178,19.717,4.161,19.699,4.144"
      />
      <path
        fill="#DFDEDE"
        d="M8.63,15.214l-2.232,2.231v0.326H8.63V15.214 M15.83,8.394c-0.138,0-0.271,0.006-0.398,0.018l-4.533,4.534
            v4.826h2.223v-6.678c0.301-0.3,0.618-0.537,0.954-0.711s0.696-0.262,1.08-0.262c0.527,0,0.921,0.155,1.179,0.464
            c0.258,0.31,0.388,0.746,0.388,1.31v5.877h2.223v-5.877c0-0.516-0.067-0.988-0.202-1.418c-0.136-0.429-0.334-0.798-0.594-1.106
            c-0.262-0.31-0.588-0.549-0.977-0.72C16.781,8.479,16.334,8.394,15.83,8.394"
      />
    </g>
  </svg>
);

export default Linkedin;
